/* AZMARA - Cross-Selling im Warenkorb
   Zeigt 3 passende Duefte unter dem Gratisversand-Balken (Warenkorb-Fenster und Warenkorb-Seite).
   Auswahl: Geschlecht (Damen/Herren/Unisex), Aehnlichkeit des Dufts, Bestseller, Preis (mindestens die fehlende Summe).
   Ausverkaufte Duefte werden bei jedem Aufruf live ausgeschlossen, wieder lieferbare tauchen von selbst wieder auf.
   Es werden nie Tags oder Original-Marken angezeigt, nur Name, Hersteller, Preis und Bild. */
(function () {
  'use strict';

  var COUNT = 3;
  var PREMIUM = 7000;
  var CHEAP = 3500;
  var PAGE_SIZE = 50;
  var POOL_TTL = 240;
  var PROFILE_TTL = 86400;
  var SKIP_HANDLES = ['gift-wrapping'];

  function has(arr, v) { return arr.indexOf(v) > -1; }

  function addAll(target, list) {
    for (var i = 0; i < list.length; i++) {
      if (!has(target, list[i])) target.push(list[i]);
    }
  }

  function tokens(x) {
    if (!x) return [];
    if (typeof x === 'string') {
      try {
        var j = JSON.parse(x);
        if (Object.prototype.toString.call(j) === '[object Array]') x = j;
      } catch (e) { /* kein JSON, normaler Text */ }
    }
    if (typeof x === 'string') x = x.split(',');
    var out = [];
    for (var i = 0; i < x.length; i++) {
      var t = String(x[i]).toLowerCase().replace(/ /g, ' ').trim();
      if (t && !has(out, t)) out.push(t);
    }
    return out;
  }

  function sim(a, b) {
    if (!a.length || !b.length) return 0;
    var n = 0;
    for (var i = 0; i < a.length; i++) { if (has(b, a[i])) n++; }
    return n / Math.sqrt(a.length * b.length);
  }

  function modeOf(cartProfiles) {
    var gset = [];
    for (var i = 0; i < cartProfiles.length; i++) {
      var g = cartProfiles[i].g;
      if (g && !has(gset, g)) gset.push(g);
    }
    if (gset.length === 1) {
      if (gset[0] === 'Unisex') return { mode: 'U', main: '' };
      return { mode: 'G', main: gset[0] };
    }
    return { mode: 'ALL', main: '' };
  }

  /* Waehlt die besten Vorschlaege. o = { pool, cartProfiles, cartHandles, gap, reached, count } */
  function pick(o) {
    var m = modeOf(o.cartProfiles);
    var cf = [], cc = [], cl = [];
    var i, k;
    for (i = 0; i < o.cartProfiles.length; i++) {
      addAll(cf, tokens(o.cartProfiles[i].f));
      addAll(cc, tokens(o.cartProfiles[i].c));
      addAll(cl, tokens(o.cartProfiles[i].l));
    }
    var strict = [], rest = [], seen = {};
    for (i = 0; i < o.pool.length; i++) {
      var c = o.pool[i];
      if (!c || !c.a || !(c.p > 0) || !c.g) continue;
      if (has(o.cartHandles, c.h) || has(SKIP_HANDLES, c.h)) continue;
      if (m.mode === 'G' && c.g !== m.main && c.g !== 'Unisex') continue;
      if (m.mode === 'U' && c.g !== 'Unisex') continue;
      if (seen[c.h]) continue;
      seen[c.h] = true;
      var reaches = o.reached ? true : c.p >= o.gap;
      var gs = 1;
      if (m.mode === 'G') gs = (c.g === m.main) ? 1 : 0.75;
      else if (m.mode === 'U') gs = (c.g === 'Unisex') ? 1 : 0.6;
      var match = 0.4 * sim(tokens(c.f), cf) + 0.3 * sim(tokens(c.c), cc) + 0.3 * sim(tokens(c.l), cl);
      var best = 1 - Math.min(1, c.r || 0);
      var fit = (!o.reached && reaches) ? Math.exp(-(c.p - o.gap) / 3000) : 0;
      var s = o.reached
        ? 0.45 * match + 0.38 * best + 0.17 * gs
        : 0.38 * match + 0.30 * best + 0.17 * gs + 0.15 * fit;
      var entry = { c: c, s: s, reaches: reaches };
      (reaches ? strict : rest).push(entry);
    }
    var list = strict;
    if (o.reached) {
      var prem = [], cheap = [], mid = [], pickedR = [], vend = {}, gcR = {};
      for (i = 0; i < strict.length; i++) {
        var pp = strict[i].c.p;
        (pp >= PREMIUM ? prem : (pp <= CHEAP ? cheap : mid)).push(strict[i]);
      }
      var take = function (arr, n) {
        while (n > 0 && arr.length) {
          var b = -1, bsc = -1e9, q;
          for (q = 0; q < arr.length; q++) {
            var sv = arr[q].s - 0.12 * (vend[arr[q].c.v] || 0) - (m.mode === 'ALL' ? 0.1 * (gcR[arr[q].c.g] || 0) : 0);
            if (sv > bsc) { bsc = sv; b = q; }
          }
          var got = arr.splice(b, 1)[0];
          pickedR.push(got);
          vend[got.c.v] = (vend[got.c.v] || 0) + 1;
          gcR[got.c.g] = (gcR[got.c.g] || 0) + 1;
          n--;
        }
      };
      take(prem, 1);
      take(cheap, 2);
      if (pickedR.length < o.count) take(prem.concat(cheap, mid), o.count - pickedR.length);
      pickedR.sort(function (a, b) { return a.c.p - b.c.p; });
      return { items: pickedR, strictCount: strict.length, anyReach: true };
    }
    if (!o.reached && strict.length < o.count) {
      rest.sort(function (a, b) { return b.c.p - a.c.p; });
      list = strict.concat(rest.slice(0, 12));
    }
    var chosen = [], vendors = {}, gcount = {};
    while (chosen.length < o.count && list.length) {
      var bi = -1, bs = -1e9;
      for (k = 0; k < list.length; k++) {
        var sc = list[k].s - 0.12 * (vendors[list[k].c.v] || 0) - (m.mode === 'ALL' ? 0.1 * (gcount[list[k].c.g] || 0) : 0) + ((!o.reached && list[k].reaches) ? 1 : 0);
        if (sc > bs) { bs = sc; bi = k; }
      }
      var w = list.splice(bi, 1)[0];
      chosen.push(w);
      vendors[w.c.v] = (vendors[w.c.v] || 0) + 1;
      gcount[w.c.g] = (gcount[w.c.g] || 0) + 1;
    }
    var anyReach = false;
    for (i = 0; i < chosen.length; i++) { if (chosen[i].reaches) anyReach = true; }
    return { items: chosen, strictCount: strict.length, anyReach: anyReach };
  }

  window.AzmaraCrossSell = { pick: pick, tokens: tokens, modeOf: modeOf };

  if (typeof document === 'undefined') return;

  /* ---------- Daten holen ---------- */

  var memo = {};

  function getJSON(url, ttl) {
    if (memo[url]) return memo[url];
    var key = 'azxs:' + url;
    var now = Date.now();
    try {
      var raw = sessionStorage.getItem(key);
      if (raw) {
        var o = JSON.parse(raw);
        if (now - o.t < ttl * 1000) {
          memo[url] = Promise.resolve(o.d);
          setTimeout(function () { delete memo[url]; }, 30000);
          return memo[url];
        }
      }
    } catch (e) { /* Speicher nicht verfuegbar */ }
    var p = fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (d) {
        try { sessionStorage.setItem(key, JSON.stringify({ t: now, d: d })); } catch (e) { /* ignorieren */ }
        return d;
      });
    memo[url] = p;
    p.then(function () { setTimeout(function () { delete memo[url]; }, 30000); }, function () { delete memo[url]; });
    return p;
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
  }

  function getProfiles(handles) {
    var res = {}, missing = [], now = Date.now();
    handles.forEach(function (h) {
      try {
        var raw = localStorage.getItem('azxs:prof:' + h);
        if (raw) {
          var o = JSON.parse(raw);
          if (now - o.t < PROFILE_TTL * 1000) { res[h] = o.d; return; }
        }
      } catch (e) { /* ignorieren */ }
      missing.push(h);
    });
    if (!missing.length) return Promise.resolve(res);
    var url = '/search?view=profile&q=' + encodeURIComponent(missing.join(','));
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (list) {
        list.forEach(function (p) {
          res[p.h] = p;
          try { localStorage.setItem('azxs:prof:' + p.h, JSON.stringify({ t: now, d: p })); } catch (e) { /* ignorieren */ }
        });
        return res;
      });
  }

  function poolUrl(tag, page, floorCents, ceilCents) {
    var u = '/collections/all/' + tag + '?view=crosssell&sort_by=best-selling&filter.v.availability=1&page=' + page;
    if (floorCents > 0) u += '&filter.v.price.gte=' + (floorCents / 100).toFixed(2);
    if (ceilCents > 0) u += '&filter.v.price.lte=' + (ceilCents / 100).toFixed(2);
    return u;
  }

  /* specs: Liste aus [tag, [seiten]] */
  function fetchPools(specs, floorCents, ceilCents) {
    var jobs = [];
    specs.forEach(function (sp) {
      sp[1].forEach(function (page) {
        jobs.push(
          getJSON(poolUrl(sp[0], page, floorCents, ceilCents), POOL_TTL).then(function (list) {
            for (var i = 0; i < list.length; i++) list[i].r = ((page - 1) * PAGE_SIZE + i) / 100;
            return list;
          }, function () { return []; })
        );
      });
    });
    return Promise.all(jobs).then(function (lists) {
      var all = [];
      lists.forEach(function (l) { all = all.concat(l); });
      return all;
    });
  }

  function specsFor(m, stage) {
    if (m.mode === 'U') {
      if (stage === 'more') return [['unisex', [3, 4]]];
      return [['unisex', [1]]];
    }
    if (m.mode === 'G') {
      var t = m.main.toLowerCase();
      if (stage === 'base') return [[t, [1, 2]], ['unisex', [1, 2]]];
      if (stage === 'more') return [[t, [3]], ['unisex', [3]]];
      return [[t, [1]], ['unisex', [1]]];
    }
    if (stage === 'base') return [['damen', [1]], ['herren', [1]], ['unisex', [1, 2]]];
    if (stage === 'more') return [['damen', [2]], ['herren', [2]], ['unisex', [3]]];
    return [['damen', [1]], ['herren', [1]], ['unisex', [1]]];
  }

  /* ---------- Anzeige ---------- */

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  function money(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function cardHtml(item, gap, reached) {
    var c = item.c;
    var badge = (!reached && c.p >= gap) ? '<span class="azxs__badge">Gratisversand</span>' : '';
    if (reached && c.p >= PREMIUM) badge = '<span class="azxs__badge">Highlight</span>';
    var img = c.im ? '<img src="' + esc(c.im) + '" alt="' + esc(c.t) + '" loading="lazy" width="240" height="240">' : '';
    return '<div class="azxs__card">' +
      '<a class="azxs__img" href="/products/' + esc(c.h) + '">' + img + '</a>' + badge +
      '<a class="azxs__name" href="/products/' + esc(c.h) + '">' + esc(c.t) + '</a>' +
      '<span class="azxs__vendor">' + esc(c.v) + '</span>' +
      '<span class="azxs__price">' + money(c.p) + '</span>' +
      '<button type="button" class="azxs__add js-grid-cart" data-id="' + esc(c.i) + '" aria-label="' + esc(c.t) + ' in den Warenkorb legen">+ Hinzufügen</button>' +
      '</div>';
  }

  var SHIP_ICON = '<svg aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 64 64"><path fill="none" stroke="#000" stroke-width="2" d="M32 54.52L10 41.95v-19.9L32 9.48l22 12.57v19.9L32 54.52z"></path><path fill="none" stroke="#000" stroke-width="2" d="M32 54.52v-19.9l22-12.57M32 34.62L10 22.05M41.7 15.02L21 28.33v8.38"></path></svg>';

  var CHECK_ICON = '<svg aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" fill="none" stroke="#000" stroke-width="1.6"></circle><path fill="none" stroke="#000" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" d="M7.5 12.5l3 3 6-6.5"></path></svg>';

  function shipHtml(gap, thr, reached) {
    if (reached) {
      return '<div class="free-shipping azxs__ship azxs__ship--done">' +
        '<div class="free-shipping-content d-flex align-items-center">' + CHECK_ICON +
        '<span>Dein Versand ist kostenlos</span></div></div>';
    }
    var pct = Math.max(0, Math.min(100, Math.round((thr - gap) / thr * 1000) / 10));
    return '<div class="free-shipping azxs__ship">' +
      '<div class="free-shipping-content d-flex align-items-center">' + SHIP_ICON +
      '<span>Nur noch ' + money(gap) + ' und dein Versand ist kostenlos</span></div>' +
      '<div class="progress"><div class="progress-bar progress-bar-striped progress-bar-animated primary" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '" style="width: ' + pct + '%;"></div></div>' +
      '</div>';
  }

  function blockHtml(result, gap, reached, kind, thr) {
    var title, sub;
    if (reached) {
      title = 'Dazu passt auch';
      sub = 'Ein besonderes Highlight und kleine Düfte zum Dazunehmen.';
    } else if (result.anyReach) {
      title = 'Jetzt Gratisversand sichern';
      sub = 'Passend zu deinem Duft – ein Klick und dein Versand ist kostenlos.';
    } else {
      title = 'Passende Düfte für dich';
      sub = 'Damit kommst du dem Gratisversand näher.';
    }
    var cards = '';
    for (var i = 0; i < result.items.length; i++) cards += cardHtml(result.items[i], gap, reached);
    return '<div class="azxs azxs--' + kind + ' azxs--ship' + '">' +
      shipHtml(gap, thr, reached) +
      '<p class="azxs__title">' + title + '</p>' +
      '<p class="azxs__sub">' + sub + '</p>' +
      '<div class="azxs__grid">' + cards + '</div>' +
      '</div>';
  }

  var hosts = [];

  function ensureHosts() {
    var list = [];
    var mini = document.querySelectorAll('.js-mini-cart-content');
    for (var i = 0; i < mini.length; i++) {
      var el = mini[i];
      var next = el.nextElementSibling;
      if (!(next && next.classList.contains('azxs-wrap'))) {
        var d = document.createElement('div');
        d.className = 'azxs-wrap azxs-wrap--drawer';
        d.hidden = true;
        el.parentNode.insertBefore(d, el.nextSibling);
        next = d;
      }
      list.push({ el: next, kind: 'drawer' });
    }
    var form = document.querySelector('[data-section-type="cart"] form.cart');
    if (form) {
      var col = form.querySelector('.col-lg-8');
      var nf = col ? col.querySelector(':scope > .azxs-wrap') : form.nextElementSibling;
      if (!(nf && nf.classList.contains('azxs-wrap'))) {
        var p = document.createElement('div');
        p.className = 'azxs-wrap azxs-wrap--page';
        p.hidden = true;
        if (col) col.appendChild(p);
        else form.parentNode.insertBefore(p, form.nextSibling);
        nf = p;
      }
      list.push({ el: nf, kind: 'page' });
    }
    hosts = list;
    return list;
  }

  function hideAll() {
    for (var i = 0; i < hosts.length; i++) { hosts[i].el.hidden = true; hosts[i].el.innerHTML = ''; }
    document.documentElement.classList.remove('azxs-on');
  }

  function showAll(result, gap, reached, thr) {
    var shown = false;
    for (var i = 0; i < hosts.length; i++) {
      if (!result.items.length) {
        hosts[i].el.innerHTML = '<div class="azxs azxs--' + hosts[i].kind + ' azxs--ship">' + shipHtml(gap, thr, reached) + '</div>';
        hosts[i].el.hidden = false;
        shown = true;
        continue;
      }
      hosts[i].el.innerHTML = blockHtml(result, gap, reached, hosts[i].kind, thr);
      hosts[i].el.hidden = false;
      shown = true;
    }
    document.documentElement.classList.toggle('azxs-on', shown);
  }

  /* ---------- Ablauf ---------- */

  function threshold() {
    var el = document.querySelector('.js-free-shipping');
    var v = el ? parseInt(el.getAttribute('data-value'), 10) : 0;
    return v > 0 ? v : 0;
  }

  var seq = 0;
  var ALL_BASE = [['damen', [1, 2]], ['herren', [1, 2]], ['unisex', [1, 2]]];
  var ALL_FILL = [['damen', [1]], ['herren', [1]], ['unisex', [1]]];

  /* Zeigt sofort Balken und graue Platzhalter, damit nichts springt, waehrend die Vorschlaege noch laden. */
  function showEarly(gap, reached, thr) {
    for (var i = 0; i < hosts.length; i++) {
      var host = hosts[i].el;
      var oldShip = host.hidden ? null : host.querySelector('.azxs__ship');
      if (oldShip) {
        var tmp = document.createElement('div');
        tmp.innerHTML = shipHtml(gap, thr, reached);
        oldShip.parentNode.replaceChild(tmp.firstChild, oldShip);
      } else {
        host.innerHTML = '<div class="azxs azxs--' + hosts[i].kind + ' azxs--ship azxs--loading">' + shipHtml(gap, thr, reached) +
          '<div class="azxs__grid"><div class="azxs__ph"></div><div class="azxs__ph"></div><div class="azxs__ph"></div></div></div>';
        host.hidden = false;
      }
    }
    document.documentElement.classList.add('azxs-on');
    restoreScroll();
  }

  /* Nach dem Hinzufuegen laedt die Warenkorb-Seite neu: dann bleibt die Box an der gleichen Stelle im Bild stehen. */
  function restoreScroll() {
    var v = null;
    try { v = sessionStorage.getItem('azxs:scroll'); sessionStorage.removeItem('azxs:scroll'); } catch (e) { /* ignorieren */ }
    if (v === null || v === undefined || v === '') return;
    var want = parseFloat(v);
    var host = document.querySelector('.azxs-wrap--page');
    if (!host || host.hidden || isNaN(want)) return;
    function go() {
      var top = host.getBoundingClientRect().top + (window.pageYOffset || 0);
      window.scrollTo(0, Math.max(0, top - want));
    }
    go();
    setTimeout(go, 350);
  }

  function refresh() {
    var my = ++seq;
    ensureHosts();
    if (!hosts.length) return;
    getCart().then(function (cart) {
      if (my !== seq) return null;
      var thr = threshold();
      if (!cart.item_count || !thr) { hideAll(); return null; }
      var gap = thr - cart.total_price;
      var reached = gap <= 0;
      showEarly(gap, reached, thr);
      var handles = [];
      cart.items.forEach(function (it) {
        if (it.handle && !has(handles, it.handle) && !has(SKIP_HANDLES, it.handle)) handles.push(it.handle);
      });
      var floor = reached ? 0 : Math.ceil(gap);
      var poolP = reached
        ? Promise.all([fetchPools(ALL_BASE, 0, CHEAP), fetchPools(ALL_FILL, PREMIUM, 0)]).then(function (pp) { return pp[0].concat(pp[1]); })
        : fetchPools(ALL_BASE, floor);
      return Promise.all([getProfiles(handles.slice(0, 15)).catch(function () { return {}; }), poolP]).then(function (parts) {
        if (my !== seq) return null;
        var map = parts[0], pool = parts[1];
        var profiles = [];
        handles.forEach(function (h) { if (map[h]) profiles.push(map[h]); });
        var m = modeOf(profiles);
        function run(pl) {
          return pick({ pool: pl, cartProfiles: profiles, cartHandles: handles, gap: gap, reached: reached, count: COUNT });
        }
        var res = run(pool);
        if (reached || res.strictCount >= COUNT) return res;
        return fetchPools(specsFor(m, 'more'), floor).then(function (more) {
          pool = pool.concat(more);
          res = run(pool);
          if (res.strictCount >= COUNT) return res;
          return fetchPools(specsFor(m, 'fill'), 0).then(function (fill) {
            return run(pool.concat(fill));
          });
        });
      }).then(function (res) {
        if (my !== seq || !res) return;
        showAll(res, gap, reached, thr);
      });
    }).catch(function (e) {
      dropPlaceholders();
      if (window.console && console.warn) console.warn('AZMARA Cross-Selling:', e);
    });
  }

  /* Bei einem Fehler bleibt der Balken stehen, nur die grauen Platzhalter verschwinden. */
  function dropPlaceholders() {
    var any = false;
    for (var i = 0; i < hosts.length; i++) {
      var ph = hosts[i].el.querySelectorAll('.azxs__ph');
      if (ph.length && ph[0].parentNode && ph[0].parentNode.parentNode) ph[0].parentNode.parentNode.removeChild(ph[0].parentNode);
      if (hosts[i].el.querySelector('.azxs__ship')) any = true;
      else { hosts[i].el.hidden = true; hosts[i].el.innerHTML = ''; }
    }
    document.documentElement.classList.toggle('azxs-on', any);
  }

  var timer = null;
  function refreshSoon() {
    if (hosts.length) document.documentElement.classList.add('azxs-on');
    clearTimeout(timer);
    timer = setTimeout(refresh, 60);
  }

  /* Reagiert sofort, wenn der Warenkorb per Ajax geaendert wurde (Hinzufuegen, Menge aendern, Entfernen), nicht erst wenn das Fenster fertig gezeichnet ist. */
  function hookCartRequests() {
    if (window.__azxsHooked) return;
    window.__azxsHooked = true;
    function isCart(u) {
      var t = String(u);
      return t.indexOf('/cart/add') > -1 || t.indexOf('/cart/change') > -1 || t.indexOf('/cart/update') > -1 || t.indexOf('/cart/clear') > -1;
    }
    if (window.fetch) {
      var origFetch = window.fetch;
      window.fetch = function (input) {
        var p = origFetch.apply(this, arguments);
        try {
          if (isCart(input && input.url ? input.url : input)) p.then(refreshSoon, function () { /* ignorieren */ });
        } catch (e) { /* ignorieren */ }
        return p;
      };
    }
    if (window.XMLHttpRequest) {
      var xOpen = XMLHttpRequest.prototype.open;
      var xSend = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function (method, url) {
        this.__azxsCart = isCart(url);
        return xOpen.apply(this, arguments);
      };
      XMLHttpRequest.prototype.send = function () {
        if (this.__azxsCart) this.addEventListener('loadend', refreshSoon);
        return xSend.apply(this, arguments);
      };
    }
  }

  function onAddClick(ev) {
    var t = ev.target && ev.target.closest ? ev.target.closest('.azxs__add') : null;
    if (!t) return;
    var wrap = t.closest('.azxs-wrap--page');
    if (wrap) {
      try { sessionStorage.setItem('azxs:scroll', String(Math.round(wrap.getBoundingClientRect().top))); } catch (e) { /* ignorieren */ }
    }
    t.classList.add('is-loading');
    t.textContent = 'Wird hinzugefügt …';
  }

  /* Der Gratisversand-Text des Themes steht in den Einstellungen auf Englisch: hier immer auf Deutsch ersetzen. */
  function germanize() {
    var els = document.querySelectorAll('.js-free-shipping-text');
    for (var i = 0; i < els.length; i++) {
      if (els[i].textContent.indexOf('free delivery') > -1) els[i].textContent = 'Dein Versand ist kostenlos';
    }
  }

  function init() {
    germanize();
    if (window.MutationObserver && document.body) {
      new MutationObserver(germanize).observe(document.body, { childList: true, subtree: true, characterData: true });
    }
    document.addEventListener('click', onAddClick, true);
    hookCartRequests();
    ensureHosts();
    var mini = document.querySelectorAll('.js-mini-cart-content');
    if (window.MutationObserver) {
      var obs = new MutationObserver(refreshSoon);
      for (var i = 0; i < mini.length; i++) obs.observe(mini[i], { childList: true });
    }
    refresh();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
